export enum PerformanceChangesByOptionValue {
  Peak_1_days = 'Peak_1_days',
  Peak_7_days = 'Peak_7_days',
  Peak_14_days = 'Peak_14_days',
  Peak_30_days = 'Peak_30_days',
  Impact_7_days = 'Impact_7_days',
  Impact_14_days = 'Impact_14_days',
  Impact_30_days = 'Impact_30_days',
}
